var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGluten({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.683 3.667c0 .326-.127.634-.358.865L8 4.857l-.325-.325a1.215 1.215 0 0 1-.358-.865c0-.327.127-.635.358-.866L8 2.476l.325.325c.231.231.358.539.358.866Zm-2.7.126 1.11 1.11c.38.38.59.887.59 1.425v1.045L6.574 6.264c-.38-.38-.59-.887-.59-1.426V3.793Zm2.334 3.58V6.329c0-.538.21-1.045.59-1.425l1.11-1.11v1.045c0 .578-.183 1.018-.591 1.426l-1.11 1.11ZM5.65 6.294l1.443 1.443c.38.38.59.887.59 1.426v1.045L6.241 8.764c-.381-.38-.591-.887-.591-1.426V6.293Zm2.667 5.702c0-.538.21-1.045.59-1.426l1.776-1.776v1.045c0 .539-.21 1.046-.59 1.426L8.317 13.04v-1.045Zm5.662-9.308A8 8 0 0 1 2.687 13.98 7.967 7.967 0 0 1 0 8a8 8 0 0 1 13.313-5.98c.235.21.457.432.666.667ZM8 15a7 7 0 0 0 5.27-11.604l-2.92 2.92v1.022c0 .539-.21 1.045-.59 1.426l-1.443 1.443V9.162c0-.539.21-1.045.59-1.426l1.426-1.426V5l2.271-2.27a7 7 0 0 0-9.875 9.874l2.596-2.596a1.984 1.984 0 0 1-.008-.17V8.793l1.776 1.776c.38.38.59.887.59 1.426v1.045l-1.776-1.776a2.031 2.031 0 0 1-.229-.275L3.396 13.27A6.972 6.972 0 0 0 8 15Z",
    fill: "#0E111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGluten);
export default __webpack_public_path__ + "static/media/gluten.bad6c4e8fa3e3095176aeef5fe05c705.svg";
export { ForwardRef as ReactComponent };